<div>
    @if (field?.props?.allowSignatureLabel && description) { 
        <div class="mb-1 ql-snow">
            <div class="ql-editor p-0" [innerHTML]="description | safe: 'html'"></div>
        </div>
    }
    <form [formGroup]="questionsForm" class="mb-4 w-full bg-white px-4 border border-[#ccd5e1] rounded-md">
        <div class="py-4 w-full">
            <div class="space-y-4">
                @for (question of questions; track i; let i = $index) {
                    <div>
                        <!-- Boolean Type  -->
                        @if (question.type === 'Boolean') {
                            <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                <input matInput class="hidden" [formControlName]="'question_' + i">
                                <mat-checkbox
                                    color="accent"
                                    [formControlName]="'question_' + i">
                                    <span class="font-medium">{{ question.question }}</span>
                                </mat-checkbox>
                            </mat-form-field>
                        }
                        
                        <!-- Yes/No Type -->
                        @if (question.type === 'YesNo') {
                            <div class="space-y-2">
                                <span>{{ question.question }}</span>
                                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                    <input matInput class="hidden" [formControlName]="'question_' + i">
                                    <mat-radio-group 
                                        [formControlName]="'question_' + i"
                                        class="flex flex-row gap-4">
                                        <mat-radio-button value="Yes">Yes</mat-radio-button>
                                        <mat-radio-button value="No">No</mat-radio-button>
                                    </mat-radio-group>
                                </mat-form-field>
                            </div>
                        }

                        <!-- Selection and MultipleSelection Types -->
                        @if (question.type === 'Selection' || question.type === 'MultipleSelection') {
                            <div class="space-y-2">
                                <span>{{ question.question }}</span>
                                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                                    <mat-select 
                                        [multiple]="question.type === 'MultipleSelection'"
                                        [formControlName]="'question_' + i"
                                        [placeholder]="question.type === 'MultipleSelection' ? 'Select options' : 'Select an option'">
                                        @for (answer of question?.answers; track $index) {
                                            <mat-option [value]="answer?.id">{{ answer?.answer }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </form>
</div>